import { IMAGES } from "@/lib/config";

export const signatureFavorites = [
  {
    key: "quesabirria",
    name: "Quesabirria Tacos",
    tag: { en: "Everyday bestseller", es: "El favorito de siempre" },
    description: { en: "Double corn tortilla quesadilla tacos with birria, served with consomé for dipping.", es: "Tacos de doble tortilla de maíz con queso y birria, con consomé para remojar." },
    price: "$15.99",
    image: IMAGES.quesabirria,
    alt: "Quesabirria tacos with melted cheese and consomé",
  },
  {
    key: "dorados",
    name: "Tacos Dorados",
    tag: { en: "Crispy classic", es: "Clásico crujiente" },
    description: { en: "Four single fried corn tortilla tacos with cheese and birria.", es: "Cuatro tacos de tortilla de maíz frita con queso y birria." },
    price: "$14.99",
    image: IMAGES.tacosDorados,
    alt: "Crispy tacos dorados with cheese and birria",
  },
  {
    key: "ramen",
    name: "Birria Ramen",
    tag: { en: "Specialty", es: "Especialidad" },
    description: { en: "Ramen cooked in our consomé, layered with meat, cheese, onion and cilantro.", es: "Ramen cocido en nuestro consomé con carne, queso, cebolla y cilantro." },
    price: "$14.99",
    image: IMAGES.birriaRamen,
    alt: "Birria ramen bowl with beef and cheese",
  },
  {
    key: "pizza",
    name: "Birria Pizza",
    tag: { en: "Made to share", es: "Para compartir" },
    description: { en: "Three 14\" tortillas layered with cheese and birria, topped with crema, queso fresco, onion and cilantro.", es: "Tres tortillas de 14\" con capas de queso y birria, con crema, queso fresco, cebolla y cilantro." },
    price: "$41.99",
    image: IMAGES.birriaPizza,
    alt: "Birria pizza topped with crema, limes, onion and cilantro",
  },
  {
    key: "fries",
    name: "Birria Fries",
    tag: { en: "Loaded", es: "Bien servidas" },
    description: { en: "Fries with nacho cheese, birria, queso fresco, sour cream, chipotle crema, onion and cilantro.", es: "Papas con queso nacho, birria, queso fresco, crema, crema de chipotle, cebolla y cilantro." },
    price: "$15.99",
    image: IMAGES.birriaFries,
    alt: "Loaded birria fries with cheese and crema",
  },
  {
    key: "pound",
    name: { en: "Birria by the Pound", es: "Birria por Libra" },
    tag: { en: "Families & events", es: "Familias y eventos" },
    description: { en: "Meat, corn tortillas and consomé—build your own tacos at home or for your event.", es: "Carne, tortillas de maíz y consomé—arma tus propios tacos en casa o en tu evento." },
    price: null,
    image: IMAGES.softTacos,
    alt: "Birria de res served with corn tortillas and consomé",
    link: "/catering",
  },
];
